/**
 * Silhouette of the Convo brand mark, on a 32x32 viewBox.
 *
 * Three places draw it: {@link ConvoIcon}, the greyed, cracked variant on the
 * global error page, and the native `ConvoMark` behind the iOS tutor FAB. Those
 * renderings differ on purpose - global-error replaces the root layout, so it
 * cannot rely on the app's stylesheet and inlines its own colours, and the
 * native one draws through react-native-svg - but the shape itself is one thing,
 * and lives here. This module holds no imports, so the error page stays as
 * dependency-light as it should be and the module crosses the `@shared-lib`
 * seam into src/ios without dragging anything with it.
 *
 * IT LIVES UNDER src/web/src/lib, NOT NEXT TO ConvoIcon, FOR THAT SEAM. Metro
 * only bundles files under the iOS project root or a watchFolder, and
 * `src/web/src/lib` is one; `src/web/src/components/ui`, where this started, is
 * not. Native shipped a hand-drawn SF Symbol instead of the brand mark for
 * exactly as long as the shape was unreachable from it.
 */
export const CONVO_MARK_PATH =
  "M13 0h6a13 13 0 0 1 13 13v6a13 13 0 0 1-13 13H5a5 5 0 0 1-5-5V13A13 13 0 0 1 13 0Z";
